import { mutatorAction } from 'satcheljs';
import type { NoteColor } from '@notes/sticky-notes-layout';
import getDefaultNoteColor from './utils/getDefaultNoteColor';
import getStore from './store';

export const resetStore = mutatorAction('resetStore', () => {
    getStore().notes.clear();
});

export const addNoteToCache = mutatorAction(
    'addNoteToCache',
    (
        remoteId: string,
        noteId: string,
        isNoteDeletedOnServer: boolean,
        title: string | undefined,
        color?: NoteColor | undefined
    ) => {
        const cachedNotes = getStore().notes;
        if (!cachedNotes.has(remoteId)) {
            cachedNotes.set(remoteId, {
                noteId: noteId,
                isNoteDeletedOnServer: isNoteDeletedOnServer,
                color: color || getDefaultNoteColor(),
                title: title,
            });
        }
    }
);

export const updateIsNoteDeletedOnServer = mutatorAction(
    'updateIsNoteDeletedOnServer',
    (remoteId: string) => {
        const cachedNotes = getStore().notes;
        let note = cachedNotes.get(remoteId);
        if (note) {
            note.isNoteDeletedOnServer = true;
        }
    }
);

export const updateNoteColor = mutatorAction(
    'updateNoteColor',
    (remoteId: string, noteColor: NoteColor) => {
        const cachedNotes = getStore().notes;
        let note = cachedNotes.get(remoteId);
        if (note) {
            note.color = noteColor;
        }
    }
);

export const updateNoteTitle = mutatorAction(
    'updateNoteTitle',
    (remoteId: string, noteTitle: string) => {
        const cachedNotes = getStore().notes;
        let note = cachedNotes.get(remoteId);
        if (note) {
            note.title = noteTitle;
        }
    }
);
